import React from "react";
import { FaGithub } from "react-icons/fa";
import { BsYoutube } from "react-icons/bs";
import { FaLinkedin } from "react-icons/fa";

const Footer = () => {
  return (
    <>

      <div className="relative w-full h-screen">
        <img
          src="https://i.ytimg.com/vi/rHbhW-iYZLI/maxresdefault.jpg"
          alt="Vlog Writing"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 flex flex-col items-center justify-center text-white text-center bg-black bg-opacity-50 px-1">
          <h2 className="text-3xl md:text-4xl font-bold">Start your storytelling journey with CilliBlog</h2>
          <p className="text-lg mt-2">Capture moments. Share thoughts. Inspire others.</p>
        </div>
      </div>


      {/* Footer */}
      <footer className="border-t pt-10 bg-gray-50 mt-20">
        <div className="container mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 px-4">
          <div className="text-center md:text-start">
            <h2 className="text-lg font-semibold mb-4">Products</h2>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-500 hover:text-black">Flutter</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">React</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Android</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">iOS</a></li>
            </ul>
          </div>
          <div className="text-center md:text-start">
            <h2 className="text-lg font-semibold mb-4">Design to code</h2>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-500 hover:text-black">Figma plugin</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Templates</a></li>
            </ul>
          </div>
          <div className="text-center md:text-start">
            <h2 className="text-lg font-semibold mb-4">Comparison</h2>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Anima</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Appsmith</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs FlutterFlow</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Monday Hero</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Retool</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Bubble</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">DhiWise vs Figma Dev Mode</a></li>
            </ul>
          </div>
          <div className="text-center md:text-start">
            <h2 className="text-lg font-semibold mb-4">Company</h2>
            <ul className="space-y-2">
              <li><a href="#" className="text-gray-500 hover:text-black">About Us</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Contact Us</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Career</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Terms of Service</a></li>
              <li><a href="#" className="text-gray-500 hover:text-black">Privacy Policy</a></li>
            </ul>
          </div>
        </div>

        {/* Bottom footer */}
        <div className="container mx-auto px-4 mt-12 pt-6 border-t flex flex-col md:flex-row justify-between items-center">
          <div className="text-xl font-semibold mb-4 md:mb-0">
            Cilli<span className="text-blue-500 font-bold">Blog</span>
          </div>
          <div className="text-gray-500 text-sm mb-4 md:mb-0">
            &copy; 2025 ParamBhog PVT. LTD. All rights reserved.
          </div>
          <div className="flex space-x-4">
            <a href="#"><FaGithub className="h-6 w-6 hover:text-black" /></a>
            <a href="#"><BsYoutube className="h-6 w-6 hover:text-red-600" /></a>
            <a href="#"><FaLinkedin className="h-6 w-6 hover:text-blue-700" /></a>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
